import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Box,
  Paper,
  BottomNavigation,
  BottomNavigationAction,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import DashboardIcon from "@mui/icons-material/SpaceDashboard";
import PeopleIcon from "@mui/icons-material/People";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import StorefrontIcon from "@mui/icons-material/Storefront";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import { Logout } from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";
import { signOut } from "firebase/auth";
import { authFirebase } from "../Conections/Firebase";
import { useThemeMode } from "../Utils/ThemeModeContext";

const menuItems = [
  { label: "Dashboard", path: "/dashboard", icon: <DashboardIcon /> },
  { label: "Créditos", path: "/prestamos-caja", icon: <AccountBalanceIcon /> },
  { label: "Deudores", path: "/deudores", icon: <PeopleIcon /> },
  { label: "Brokers", path: "/brokers", icon: <StorefrontIcon /> },
];

const NavbarProject = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const location = useLocation();
  const { mode, toggleMode } = useThemeMode();

  const cerrarSesion = async () => {
    try {
      await signOut(authFirebase);
      localStorage.setItem("user", "");
      navigate("/login");
    } catch (error) {
      console.error("Error al cerrar sesión:", error.message);
    }
  };

  return (
    <>
      <AppBar position="static" sx={{ backgroundColor: "#1976d2" }}>
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>
            AppInvest
          </Typography>

          {isMobile ? (
            <Box sx={{ display: "flex", gap: 0.5 }}>
              <IconButton
                color="inherit"
                onClick={toggleMode}
                aria-label="Cambiar tema"
              >
                {mode === "dark" ? <LightModeIcon /> : <DarkModeIcon />}
              </IconButton>
              <IconButton color="inherit" onClick={cerrarSesion} aria-label="Cerrar sesión">
                <Logout />
              </IconButton>
            </Box>
          ) : (
            <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
              {menuItems.map((item) => (
                <Button
                  key={item.path}
                  color="inherit"
                  onClick={() => navigate(item.path)}
                  sx={{
                    borderBottom:
                      location.pathname === item.path
                        ? "2px solid white"
                        : "2px solid transparent",
                    textTransform: "none",
                  }}
                >
                  {item.label}
                </Button>
              ))}
              <IconButton color="inherit" onClick={toggleMode} aria-label="Cambiar tema">
                {mode === "dark" ? <LightModeIcon /> : <DarkModeIcon />}
              </IconButton>
              <Button color="inherit" onClick={cerrarSesion} startIcon={<Logout />}>
                Cerrar sesión
              </Button>
            </Box>
          )}
        </Toolbar>
      </AppBar>

      {isMobile && (
        <Paper
          elevation={8}
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: (t) => t.zIndex.appBar,
          }}
        >
          <BottomNavigation
            value={location.pathname}
            onChange={(_, newValue) => navigate(newValue)}
            showLabels
          >
            {menuItems.map((item) => (
              <BottomNavigationAction
                key={item.path}
                label={item.label}
                value={item.path}
                icon={item.icon}
              />
            ))}
          </BottomNavigation>
        </Paper>
      )}
    </>
  );
};

export default NavbarProject;
